export const SEARCH_WORD_TYPE = {
  /** 0：底纹词(不支持搜索) */
  DEFAULT: 0,
  /** 1：策略挖掘词(普通、支持搜索) */
  NORMAL: 1,
  /** 2：策略挖掘词(特殊文案带icon、支持搜索) */
  SPECIAL: 2
};

export const SEARCH_RESULT_TYPE = {
  /**https://km.sankuai.com/collabpage/2195958361
    * 1-带下挂菜的搜索结果  */
  PRODUCTLISTQUERY: 1,
  /** 2-不带下挂菜的搜索结果 */
  QUERY: 2,
  /** 3-相关推荐，代表是推荐更多中推荐的非query词召回结果 */
  NEWRECOMMEND: 3
};

export const USER_GET_MODES = {
  delivery: 'delivery', // 外卖
  pickup: 'pickup' // 自提
};

/**
 * 搜索引导页搜索框点击-1-主动输入；2-配置的搜索词
 */
export const InputKeywordType = {
  InputText: 1, // 1-主动输入；
  DefaultText: 2, // 2-配置的搜索词
};
